import USER_LOGGED from '../../graphql/user/logged.graphql'
import USER_LOGIN from '../../graphql/user/login.graphql'
import USER_LOGOUT from '../../graphql/user/logout.graphql'
import USER_CREATE from '../../graphql/user/create.graphql'
import USER_UPDATE from '../../graphql/user/update.graphql'
import USER_LIST from '../../graphql/user/list.graphql'
import USER_DELETE from '../../graphql/user/delete.graphql'
import USER_ZONES from '../../graphql/user/zones.graphql'

import {processMutation, processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        list: [],
        detail: null,
        logged: {},
        zones: []
    },

    mutations: {
        ...genericMutations('list', 'detail', 'logged', 'zones'),
    },

    actions: {
        async logged({commit, dispatch}) {
            const result = await processQuery(this, USER_LOGGED, 'user.logged')
            commit('setLogged', result)
            return result
        },

        async login({commit, dispatch}, data) {
            const result = await processMutation(this, USER_LOGIN, 'user.login', data)
            if (result.ok) {
                commit('setLogged', result.user)
            }
            return result
        },

        async logout({commit, dispatch}) {
            const result = await processMutation(this, USER_LOGOUT, 'user.logout')
            if (result.ok) {
                commit('setLogged', null)
            }
        },

        async list({commit}) {
            return await processQuery(this, USER_LIST, 'user.list', {}, 'user/setList')
        },

        async create({commit}, data) {
            return await processMutation(this, USER_CREATE, 'user.create', data)
        },

        async delete({commit}, userId) {
            return await processMutation(this, USER_DELETE, 'user.delete', {id: userId})
        },

        async update({commit}, data) {
            data.id = parseInt(data.id)
            return await processMutation(this, USER_UPDATE, 'user.update', data)
        },

        async zones({commit}) {
            return await processQuery(this, USER_ZONES, 'user.zones', {}, 'user/setZones')
        },
    }
}